import { useContext } from "react";
import { HostPortalContext } from "@/contexts/portalBranding";
import { NotFound } from "@/pages/NotFound";
import { PublicBrandDetailView } from "@/pages/store/PublicBrandDetails";

/**
 * `/join` only means something on a brand's portal, where the subdomain says
 * which brand it is. On the marketplace apex there is no brand to join, so it
 * is an ordinary 404 rather than the join page stuck on a spinner — which is
 * what rendering the page with no username would produce.
 *
 * An unclaimed subdomain never reaches here: PortalHostGate answers those
 * above the router.
 */
export function PortalJoinRoute() {
  const { branding } = useContext(HostPortalContext);
  return branding?.brandUsername ? <PublicBrandDetailView /> : <NotFound />;
}
